export default "__VITE_ASSET__B3p0VEFi__"